// extracted by mini-css-extract-plugin
export default {"root":"MenuLabel_root__vC8Wv","clicked":"MenuLabel_clicked__Tr0Gu","isOpen":"MenuLabel_isOpen__gDCZN"};